import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createCardsCategories(data) {
  return axiosInstance.post(`card-categories/create`, formatRequest(data));
}

export function updateCardsCategories(data) {
  return axiosInstance.post(`card-categories/update`, formatRequest(data));
}

export function getCardsCategoriesList(data) {
  return axiosInstance.post(`card-categories/list`, formatRequest(data));
}

export function deleteCardsCategories(data) {
  return axiosInstance.post(`card-categories/delete`, formatRequest(data));
}

export function detailsCardsCategories(data) {
  return axiosInstance.post(`card-categories/details`, formatRequest(data));
}
